const currencyFormatter = (amount) => {
    const fromPenceToPound = amount / 100;
return "£" + fromPenceToPound.toFixed(2) 
}

export default currencyFormatter